import React from 'react';
import SEO from '../components/SEO';

const Privacy: React.FC = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Privacy Policy",
    "description": "Privacy policy for ReelVindicator.com"
  };

  return (
    <>
      <SEO
        title="Privacy Policy - ReelVindicator"
        description="Read our privacy policy to understand how ReelVindicator.com collects, uses, and protects your personal information."
        schema={schema}
      />

      <div className="pt-20 pb-12">
        <section className="py-12 bg-gradient-to-br from-dark-surface to-dark-bg">
          <div className="container mx-auto px-4">
            <h1 className="text-5xl md:text-6xl font-bold text-center mb-4">
              <span className="text-gradient">Privacy Policy</span>
            </h1>
            <p className="text-gray-400 text-center">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4 max-w-4xl">
            <div className="glass p-8 rounded-xl space-y-8">
              <div>
                <h2 className="text-3xl font-bold mb-4">1. Introduction</h2>
                <p className="text-gray-400 leading-relaxed">
                  ReelVindicator.com ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, 
                  use, disclose, and safeguard your information when you visit our website. Please read this privacy policy carefully. 
                  If you do not agree with the terms of this privacy policy, please do not access the site.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">2. Information We Collect</h2>
                <p className="text-gray-400 leading-relaxed mb-4">We may collect information about you in a variety of ways. The information we may collect includes:</p>
                <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                  <li><strong>Personal Data:</strong> Name, email address, and other contact information you voluntarily provide</li>
                  <li><strong>Derivative Data:</strong> Information our servers automatically collect when you access the site, such as your IP address, browser type, and access times</li>
                  <li><strong>Financial Data:</strong> We do not collect financial information directly, but may receive information about transactions through affiliate partners</li>
                  <li><strong>Mobile Device Data:</strong> Device information, such as your mobile device ID, model, and manufacturer</li>
                </ul>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">3. Use of Your Information</h2>
                <p className="text-gray-400 leading-relaxed mb-4">Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the site to:</p>
                <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                  <li>Create and manage your account</li>
                  <li>Email you regarding your account or order</li>
                  <li>Fulfill and manage purchases, orders, and other transactions</li>
                  <li>Generate a personal profile about you to make future visits more personalized</li>
                  <li>Increase the efficiency and operation of the site</li>
                  <li>Monitor and analyze usage and trends to improve your experience</li>
                  <li>Notify you of updates to the site</li>
                  <li>Perform other business activities as needed</li>
                </ul>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">4. Disclosure of Your Information</h2>
                <p className="text-gray-400 leading-relaxed mb-4">We may share information we have collected about you in certain situations. Your information may be disclosed as follows:</p>
                <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                  <li><strong>By Law or to Protect Rights:</strong> If we believe the release of information is necessary to respond to legal process or protect rights, property, or safety</li>
                  <li><strong>Third-Party Service Providers:</strong> We may share your information with third parties that perform services for us or on our behalf</li>
                  <li><strong>Affiliate Partners:</strong> We may share information with casino partners when you click on affiliate links</li>
                  <li><strong>Business Transfers:</strong> We may share or transfer your information in connection with any merger or sale of company assets</li>
                </ul>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">5. Security of Your Information</h2>
                <p className="text-gray-400 leading-relaxed">
                  We use administrative, technical, and physical security measures to help protect your personal information. While we have taken 
                  reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures 
                  are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">6. Policy for Children</h2>
                <p className="text-gray-400 leading-relaxed">
                  We do not knowingly solicit information from or market to children under the age of 18. If we learn that we have collected personal 
                  information from a child under age 18 without verification of parental consent, we will delete that information as quickly as possible.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">7. Your Rights</h2>
                <p className="text-gray-400 leading-relaxed mb-4">Depending on your location, you may have the following rights regarding your personal information:</p>
                <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                  <li>The right to access – You have the right to request copies of your personal data</li>
                  <li>The right to rectification – You have the right to request correction of inaccurate data</li>
                  <li>The right to erasure – You have the right to request deletion of your personal data</li>
                  <li>The right to restrict processing – You have the right to request restriction of processing</li>
                  <li>The right to data portability – You have the right to request transfer of your data</li>
                  <li>The right to object to processing – You have the right to object to our processing of your data</li>
                </ul>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">8. Contact Us</h2>
                <p className="text-gray-400 leading-relaxed">
                  If you have questions or comments about this Privacy Policy, please contact us through our website contact form.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Privacy;

